import theme from "src/themeNew";

const styles = {
  container: {
    height: '100%',
    width: '400px',
    display: 'flex',
    flexDirection: 'column'
  },
  modalHeader: {
    height: '72px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid #4C4E641F',
    padding: '16px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: theme.palette.text.primary,
    lineHeight: '28px',
    letter: '-0.25px',
  },
  closeBtn: {
    padding: '0px',
  },
  closeIcon: {
    height: '18px',
    width: '18px',
    color: theme.palette.text.secondary,
  },
  modalContent: {
    flex: 1,
    padding: '20px 24px',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  fieldContainer: {
    marginBottom: '16px',
  },
  textField: {
    color: theme.palette.text.primary,
    width: '100%',
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.white,
      padding: '4px !important',
      fontSize: '13px !important',
      '& fieldset': {
        border: `1px solid ${theme.palette.border.input} !important`,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.border.input} !important`,
      }
    },
  },
  select: {
    color: theme.palette.text.primary,
    width: '100%',
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.white,
      padding: '4px !important',
      fontSize: '13px !important',
      '& fieldset': {
        border: `1px solid ${theme.palette.border.input} !important`,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.border.input} !important`,
      }
    },
  },
  modalFooter: {
    height: '102px',
    width: '100%',
    padding: '32px 20px',
    border: `1px solid ${theme.palette.border.footer}`,
    boxShadow: `0px 2px 6px 0px ${theme.palette.boxShadow.primary}`
  },
  description: {
    fontSize: '13px',
    color: theme.palette.text.secondary,
    marginBottom: '24px',
    lineHeight: '20px',
  },
  reviewTable: {
    '& .MuiTableCell-root': {
      padding: '15px 16px',
      fontSize: '13px',
    },
    '& .MuiTableRow-root': {
      height: '60px',
    },
    '& .MuiTableHead-root .MuiTableCell-root': {
      border: 'none',
      backgroundColor: theme.palette.background.tableHeader,
      position: 'relative',
      '&:not(:last-child)::after': {
        content: '""',
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        height: '30%',
        width: '1.5px',
        backgroundColor: theme.palette.border.header,
      },
    },
  },
  sectionSeparator: {
    width: '100%',
    height: '1px',
    backgroundColor: theme.palette.border.header,
    margin: '16px 0',
  },
  distributeSection: {
    padding: '16px 20px',
    borderTop: `1px solid ${theme.palette.border.header}`,
  },
  distributeSectionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  distributeContainer: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: '8px',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    flex: '0 0 auto',
    width: '55%',
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: '0 0 auto',
  },
  statusText: {
    fontSize: '13px',
    fontWeight: '500',
  },
  verticalSeparator: {
    width: '1px',
    height: '16px',
    backgroundColor: theme.palette.border.header,
  },
  editInput: {
    '& .MuiOutlinedInput-root': {
      height: '32px',
      fontSize: '13px',
      '& fieldset': {
        border: `1px solid ${theme.palette.border.input}`,
      },
      '&:hover fieldset': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
      '&.Mui-focused fieldset': {
        border: `2px solid ${theme.palette.primary.main}`,
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 12px',
      fontSize: '13px',
    },
  },
  actionButton: {
    padding: '4px',
    margin: '0 2px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  errorCard: {
    borderRadius: '8px',
    padding: '12px 16px',
    margin: '0 20px 16px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    border: '1px solid rgba(244, 67, 54, 0.3)',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
  errorIcon: {
    color: theme.palette.error.main,
    width: '24px',
    height: '24px',
  },
  errorText: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    fontWeight: '400',
  },
};

export default styles;
